/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TeamBasic } from './TeamBasic';
import {
    TeamBasicFromJSON,
    TeamBasicFromJSONTyped,
    TeamBasicToJSON,
    TeamBasicToJSONTyped,
} from './TeamBasic';
import type { StandingRow } from './StandingRow';
import {
    StandingRowFromJSON,
    StandingRowFromJSONTyped,
    StandingRowToJSON,
    StandingRowToJSONTyped,
} from './StandingRow';
import type { MatchSummary } from './MatchSummary';
import {
    MatchSummaryFromJSON,
    MatchSummaryFromJSONTyped,
    MatchSummaryToJSON,
    MatchSummaryToJSONTyped,
} from './MatchSummary';

/**
 * 
 * @export
 * @interface GroupWithResults
 */
export interface GroupWithResults {
    /**
     * 
     * @type {string}
     * @memberof GroupWithResults
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupWithResults
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupWithResults
     */
    bracket?: string;
    /**
     * 
     * @type {Array<StandingRow>}
     * @memberof GroupWithResults
     */
    standings?: Array<StandingRow>;
    /**
     * 
     * @type {Array<MatchSummary>}
     * @memberof GroupWithResults
     */
    matches?: Array<MatchSummary>;
    /**
     * 
     * @type {Array<TeamBasic>}
     * @memberof GroupWithResults
     */
    teams?: Array<TeamBasic>;
}

/**
 * Check if a given object implements the GroupWithResults interface.
 */
export function instanceOfGroupWithResults(value: object): value is GroupWithResults {
    return true;
}

export function GroupWithResultsFromJSON(json: any): GroupWithResults {
    return GroupWithResultsFromJSONTyped(json, false);
}

export function GroupWithResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): GroupWithResults {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'bracket': json['bracket'] == null ? undefined : json['bracket'],
        'standings': json['standings'] == null ? undefined : ((json['standings'] as Array<any>).map(StandingRowFromJSON)),
        'matches': json['matches'] == null ? undefined : ((json['matches'] as Array<any>).map(MatchSummaryFromJSON)),
        'teams': json['teams'] == null ? undefined : ((json['teams'] as Array<any>).map(TeamBasicFromJSON)),
    };
}

export function GroupWithResultsToJSON(json: any): GroupWithResults {
    return GroupWithResultsToJSONTyped(json, false);
}

export function GroupWithResultsToJSONTyped(value?: GroupWithResults | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'bracket': value['bracket'],
        'standings': value['standings'] == null ? undefined : ((value['standings'] as Array<any>).map(StandingRowToJSON)),
        'matches': value['matches'] == null ? undefined : ((value['matches'] as Array<any>).map(MatchSummaryToJSON)),
        'teams': value['teams'] == null ? undefined : ((value['teams'] as Array<any>).map(TeamBasicToJSON)),
    };
}

